export interface MagentoStockItem {
  backorders: number;
  enable_qty_increments: boolean;
  is_decimal_divided: boolean;
  is_in_stock: boolean;
  is_qty_decimal: boolean;
  item_id: number;
  low_stock_date: undefined;
  manage_stock: boolean;
  max_sale_qty: number;
  min_qty: number;
  min_sale_qty: number;
  notify_stock_qty: number;
  product_id: number;
  qty: number;
  qty_increments: number;
  show_default_notification_message: boolean;
  stock_id: number;
  stock_status_changed_auto: number;
  use_config_backorders: boolean;
  use_config_enable_qty_inc: boolean;
  use_config_manage_stock: boolean;
  use_config_max_sale_qty: boolean;
  use_config_min_qty: boolean;
  use_config_min_sale_qty: number;
  use_config_notify_stock_qty: boolean;
  use_config_qty_increments: boolean;
}
